import React from 'react'

export const SwivuSeparator = () => {
  return (
    <div className="shrink-0 bg-border h-[1px] w-full my-4"></div>
  )
}
